export default __webpack_public_path__ + "static/media/minus-circle.2f714fe8.svg";